import { useState } from 'react';
import { ButtonMain } from '@quero-delivery/quero-components-web';
import type { TaxPayerObj } from './ModalCancelDelivery';
import ModalCancelDelivery, { TAX_PAYER_OPTIONS } from './ModalCancelDelivery';

interface CancelDeliveryProps {
  cancelDelivery(
    collectTaxOfPlace: boolean,
    passOnTaxForMotoboy: boolean,
  ): void;
  isActionLoading: boolean;
  disabled: boolean;
  isFinishedDelivery?: boolean;
}

function CancelDelivery({
  cancelDelivery,
  isActionLoading,
  disabled,
  isFinishedDelivery,
}: CancelDeliveryProps) {
  const [isModalOpened, setIsModalOpened] = useState(false);

  function handleCancelDelivery(taxPayers: TaxPayerObj[]) {
    const collectTaxOfPlace = taxPayers.includes(TAX_PAYER_OPTIONS.PLACE);
    const passOnTaxForMotoboy = taxPayers.includes(TAX_PAYER_OPTIONS.MOTOBOY);

    cancelDelivery(collectTaxOfPlace, passOnTaxForMotoboy);
  }

  return (
    <div style={{ cursor: 'default' }}>
      <ButtonMain
        textFirst="cancelar"
        tertiary
        onClick={event => {
          event.stopPropagation();
          setIsModalOpened(true);
        }}
        loading={isActionLoading}
        disabled={isActionLoading || disabled}
      />

      {isModalOpened && (
        <ModalCancelDelivery
          isFinishedDelivery={isFinishedDelivery}
          opened={!!isModalOpened}
          onClose={() => setIsModalOpened(false)}
          disabled={disabled}
          loading={isActionLoading}
          onCancel={handleCancelDelivery}
        />
      )}
    </div>
  );
}

export default CancelDelivery;
